import React from "react";
import {
  AiFillFacebook,
  AiFillInstagram,
  AiFillLinkedin,
} from "react-icons/ai";
import { FaXTwitter } from "react-icons/fa6";
import './SocialMedia.scss';

function SocialMedia() {

  return (
    <>
        <ul>
            <li className="social-icons">
                <a
                href="https://www.instagram.com/kleanleaf"
                target="_blank"
                rel="noreferrer"
                className="icon-colour home-social-icons"
                >
                <AiFillInstagram />
                </a>
            </li>
            <li className="social-icons">
                <a
                href="https://www.linkedin.com/company/101113237/admin/dashboard/"
                target="_blank"
                rel="noreferrer"
                className="icon-colour home-social-icons"
                aria-label="Klean Leaf on LinkedIn"
                >
                <AiFillLinkedin />
                </a>
            </li>
            <li className="social-icons">
                <a
                href="https://x.com/kleanleaf"
                target="_blank"
                rel="noreferrer"
                className="icon-colour  home-social-icons"
                aria-label="Klean Leaf on X"
                >
                <FaXTwitter />
                </a>
            </li>
            <li className="social-icons">
                <a
                href="https://www.facebook.com/profile.php?id=61591538740861"
                target="_blank"
                rel="noreferrer"
                className="icon-colour  home-social-icons"
                >
                <AiFillFacebook />
                </a>
            </li>
            
        </ul>
   
    </>
  );
}
export default SocialMedia;
